import {useEffect} from "react";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";

import {setLookViewType} from "../../../../../actions/lookFunctions";
import store from "../../../../../store";
import {usePrevious} from "../../../../../misc/helperHooks";

export const getLookJourneyViewTypeFromWizardGroup = (wizardGroup) => {
  if (!wizardGroup || !wizardGroup.viewType) {
    return null;
  }
  switch (wizardGroup.viewType) {
    case 1:
      return 3
    case 2:
      return 2
    case 3:
      return 4
    case 4:
      return 1
    default:
      return 1
  }
}

export const checkIfNeedToUpdateViewType = (wizardGroup) => {
  const {lookViewType} = store.getState().lookState;
  let newViewType = getLookJourneyViewTypeFromWizardGroup(wizardGroup) || 1;
  // console.log("wizardGroup viewType", wizardGroup.viewType, newViewType, lookViewType);
  console.log("wizardGroup", wizardGroup);
  if (lookViewType !== newViewType) {
    store.dispatch(setLookViewType(newViewType))
  }
}

export const useUpdateLookWizardViewType = (wizardGroup) => {
  const prevWizardGroup = usePrevious(wizardGroup);

  useEffect(() => {
    if (!wizardGroup || IS_PRODUCT_JOURNEY) {
      return
    }
    if (prevWizardGroup && (prevWizardGroup.id === wizardGroup.id)) {
      return
    }
    if (prevWizardGroup && prevWizardGroup.mergedGroups && wizardGroup.mergedGroups
      && (prevWizardGroup.mergedGroups[0] === wizardGroup.mergedGroups[0])) { // merged groups different group
      return
    }
    checkIfNeedToUpdateViewType(wizardGroup);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wizardGroup]);
}
